import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasStepsComponent } from './steps/gas-steps.component';
import { GasHorizontalStepsComponent } from './horizontal-steps/gas-horizontal-steps.component';
import { GasVerticalStepsComponent } from './vertical-steps/vertical-steps.component';
import { GasButtonModule } from './../../forms/gas-button/gas-button.module';
import { GasDividerModule } from './../gas-divider/gas-divider.module';

const COMPONENTS = [
  GasStepsComponent,
  GasHorizontalStepsComponent,
  GasVerticalStepsComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
    GasButtonModule,
    GasDividerModule,
  ],
})
export class GasStepsModule { }
